import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "student-groups-expand",
  "use": "student-groups-expand-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 9\" id=\"student-groups-expand\"><path d=\"M9 5.25H5.25V9h-1.5V5.25H0v-1.5h3.75V0h1.5v3.75H9z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol